import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiTreemapChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-treemap-chart" />;
}
